/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _ThymicEpisodeForm;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { service } from "@ember/service";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import JournalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import ThymicEpisodeOccurredJournalEvent from "core/models/thymic-episode-occurred-journal-event";
import dayjs from "dayjs";
import { EmberChangeset } from "ember-changeset";
import { validateNumber, validatePresence } from "ember-changeset-validations/validators";
import { IntlService } from "ember-intl";
import styles from "./index.module.css";
/* eslint-disable parog-web/migrate-non-patch-forms */
let ThymicEpisodeForm = (_class = (_ThymicEpisodeForm = class ThymicEpisodeForm extends JournalEventBasedComponent {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "styles", styles);
    _defineProperty(this, "journalEventProperties", ["occurredAt", "episodeType", "episodeSeverity", "withAnxiousDistress", "withMixedCharacteristics", "withPsychoticCongruentWithMood", "withPsychoticNotCongruentWithMood", "withCatatonia", "withMelancholicCharacteristics", "wihOnsetDuringPeripartum", "withAtypicalCharacteristics", "episodeDuration", "hospitalization", "tsPresence", "commentary"]);
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
    if (this.args.onChangesetCreated) {
      this.args.onChangesetCreated(this.changeset);
    }
    this.forceQuit = this.args.forceQuit || false;
  }
  willDestroy() {
    if (this.args.onChangesetDestroyed) {
      this.args.onChangesetDestroyed(this.changeset);
    }
  }
  get validations() {
    // FIXME add the required validatiosn in the yml + change the type of episodeDuration
    const validations = this.journalEventClass.validations(this.intl);
    validations["hospitalization"] = validatePresence({
      presence: true,
      description: "L'hospitalisation"
    });
    validations["tsPresence"] = validatePresence({
      presence: true,
      description: "La présence d'une TS"
    });
    validations["episodeDuration"] = validateNumber({
      integer: true,
      positive: true,
      allowBlank: true,
      description: "La durée de l'épisode en semaine"
    });
    return validations;
  }
  get isDepressiveEpisode() {
    return this.changeset.get("episodeType") === "depressive";
  }
  get patientAgeAtTheTimeOfTheEpisode() {
    const episodeDate = this.changeset.get("occurredAt");
    const birthday = this.args.patient.birthday;
    return episodeDate ? dayjs(episodeDate).diff(dayjs(birthday), "years") : null;
  }
  retrieveModel() {
    return this.args.model || super.retrieveModel();
  }
}, _defineProperty(_ThymicEpisodeForm, "journalEventClass", ThymicEpisodeOccurredJournalEvent), _defineProperty(_ThymicEpisodeForm, "forcDisplayName", "Épisode thymique"), _defineProperty(_ThymicEpisodeForm, "fullComponentId", "thymic-episode/edition-form"), _ThymicEpisodeForm), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ThymicEpisodeForm as default };